module.exports = __webpack_public_path__ + "static/media/burgerClose.svg";